import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unon",
  "use": "unon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"unon\"><title>question-circle</title><g data-name=\"图层 2\"><path d=\"M12 24a12 12 0 1 1 8.49-3.51A12 12 0 0 1 12 24zm-.15-7a1 1 0 1 0 1 1 1 1 0 0 0-1-1zM12 6.64a2.67 2.67 0 0 1 1.9.82 2.15 2.15 0 0 1 .62 1.61c0 .51 0 1-1.56 2.5A5.45 5.45 0 0 0 11 14.63a.85.85 0 0 0 .19.62.79.79 0 0 0 .57.3h.08a.84.84 0 0 0 .84-.76c0-.56.59-1.19 1.43-2 1.66-1.67 2-2.52 2.06-3.61a3.88 3.88 0 0 0-1.08-2.87A4.33 4.33 0 0 0 12 5a4.2 4.2 0 0 0-4.2 4.2.85.85 0 1 0 1.69.06v-.1A2.51 2.51 0 0 1 12 6.65z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/unon.svg
// module id = P/W0
// module chunks = 6